import React from "react";
import { Tabs } from "antd";
import MerchantIncome from "./merchantIncome";
import MerchantVatOut from "./merchantVatOut";

const MerchantIncomePage = () => {
  const tabItems = [
    {
      key: "income",
      label: "Орлого",
      children: <MerchantIncome />,
    },
    {
      key: "vatOut",
      label: "НӨАТ гаргалт",
      children: <MerchantVatOut />,
    },
  ];

  return (
    <div className="mt-1">
      <Tabs items={tabItems} />
    </div>
  );
};

export default MerchantIncomePage;
